import { render, staticRenderFns } from "./SidebarObjectAdded.vue?vue&type=template&id=6a417e4e&scoped=true&"
import script from "./SidebarObjectAdded.vue?vue&type=script&lang=js&"
export * from "./SidebarObjectAdded.vue?vue&type=script&lang=js&"
import style0 from "./SidebarObjectAdded.vue?vue&type=style&index=0&id=6a417e4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a417e4e",
  null
  
)

export default component.exports